import React  from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Table from './TableStyle';
import moment from 'moment';

function List({}) {
  const { t } = useTranslation();
  const columns = [
    {
      title: t('date'),
      dataIndex: 'date',
      key: 'date',
      render: (text, record) => {
        return <div className="item-row">{record.date}</div>;
      },
      width: '15%',
      sorter: (a, b) => {
        let firstDate = a.date.split(' ');
        let secondtDate = b.date.split(' ');
        firstDate.splice(2, 1);
        secondtDate.splice(2, 1);
        return (
          moment(firstDate.join(' '), 'DD.MMMM:HH:MM').unix() -
          moment(secondtDate.join(' '), 'DD.MMMM:HH:MM').unix()
        );
      },
    },
    {
      title: t('storage'),
      dataIndex: 'storage',
      key: 'storage',
      render: (text, record) => {
        return <div className="item-row">{record.storage}</div>;
      },
      sorter: (a, b) => a.storage.length - b.storage.length,
      width: '20%',
    },
    {
      title: t('box'),
      dataIndex: 'box',
      key: 'box',
      render: (text, record) => {
        return <div className="item-row">{record.box}</div>;
      },
      sorter: (a, b) => a.storage.length - b.storage.length,
      width: '20%',
    },
    {
      title: t('user'),
      dataIndex: 'user',
      key: 'user',
      width: '20%',
      render: (text, record) => {
        return (
          <div className="item-row">
            <span>{record.user}</span>
          </div>
        );
      },
      sorter: (a, b) => a.storage.length - b.storage.length,
    },
    {
      title: t('target'),
      dataIndex: 'target',
      key: 'target',
      width: '20%',
      render: (text, record) => {
        return <div className="item-row">{record.target}</div>;
      },
      sorter: (a, b) => a.storage.length - b.storage.length,
    },
  ];

  const dataCol = [
    {
      date: '20 мая в 14:23',
      storage: 'Дербеневская 5',
      box: 'F-03-02',
      user: 'Александра Ивченко',
      target: 'Бокс закрыт',
    },
    {
      date: '26 мая в 14:23',
      storage: 'УДербеневская 5',
      box: 'F-02-02',
      user: 'Иван Ивченко',
      target: 'Бокс открыт',
    },
  ];

  return (
    <>
      <Table
        className="w-full"
        pagination={false}
        columns={columns}
        showSorterTooltip={false}
        dataSource={dataCol}
      />
    </>
  );
}

List.propTypes = {};

export default List;
